import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { Backpack, Gem, ShoppingCart, User } from 'lucide-react'
import useAudioManager from '../hooks/useAudioManager'
import useAppStore from '../store/useAppStore'
import { getDesktopGameModeNavigationItems } from '../config/navigationConfig'

const DesktopNavigation = () => {
  const { t } = useTranslation()
  const balance = useAppStore((state) => state.balance)
  const { playSound } = useAudioManager({
    hover: 'hover',
    pick: 'pick'
  })

  const gameModeItems = getDesktopGameModeNavigationItems(t)

  const handleNavClick = () => {
    try {
      playSound('pick')

      if (window.Telegram?.WebApp?.HapticFeedback) {
        window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy')
      }
    } catch (error) {
      // Игнорируем ошибки вибрации
    }
  }

  const handleNavHover = () => {
    playSound('hover')
  }

  return (
    <header className="sticky top-0 z-40 bg-dark-primary/90 backdrop-blur-xl">
      <div className="mx-auto w-full max-w-screen-xl px-6">
        <div className="space-y-4  p-4 lg:px-6 lg:py-5">
          <div className="flex items-center justify-between gap-6">
            <NavLink to="/" onClick={handleNavClick} className="shrink-0">
              <h1 data-text="SKINOZ" className="glitch bg-gradient-to-r from-accent-primary to-accent-secondary bg-clip-text text-4xl font-orbitron font-black text-transparent">
                SKINOZ
              </h1>
            </NavLink>

            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 px-4 py-3 text-sm font-semibold text-accent-primary">
                <Gem size={16} />
                <span>{balance.toLocaleString()}</span>
              </div>

              <NavLink
                to="/payment"
                onClick={handleNavClick}
                onMouseEnter={handleNavHover}
                className="rounded-2xl bg-gradient-to-r from-accent-primary to-accent-secondary px-5 py-3 text-sm font-semibold text-dark-primary transition-opacity duration-100 hover:opacity-90"
              >
                {t('home.topUp')}
              </NavLink>

              <NavLink
                to="/market"
                onClick={handleNavClick}
                onMouseEnter={handleNavHover}
                className={({ isActive }) =>
                  classNames(
                    'flex items-center gap-2 rounded-2xl border px-4 py-3 text-sm font-medium transition-all duration-100',
                    {
                      'border-accent-primary/30 bg-accent-primary/12 text-accent-primary shadow-[0_0_20px_rgba(0,255,127,0.1)]': isActive,
                      'border-white/10 bg-white/5 text-text-secondary hover:text-white': !isActive
                    }
                  )
                }
              >
                <ShoppingCart size={16} />
                <span>{t('market.title')}</span>
              </NavLink>

              <NavLink
                to="/inventory"
                onClick={handleNavClick}
                onMouseEnter={handleNavHover}
                className={({ isActive }) =>
                  classNames(
                    'flex items-center gap-2 rounded-2xl border px-4 py-3 text-sm font-medium transition-all duration-100',
                    {
                      'border-accent-primary/30 bg-accent-primary/12 text-accent-primary shadow-[0_0_20px_rgba(0,255,127,0.1)]': isActive,
                      'border-white/10 bg-white/5 text-text-secondary hover:text-white': !isActive
                    }
                  )
                }
              >
                <Backpack size={16} />
                <span>{t('nav.inventory')}</span>
              </NavLink>

              <NavLink
                to="/profile"
                onClick={handleNavClick}
                onMouseEnter={handleNavHover}
                className={({ isActive }) =>
                  classNames(
                    'flex items-center gap-2 rounded-2xl border px-4 py-3 text-sm font-medium transition-all duration-100',
                    {
                      'border-accent-primary/30 bg-accent-primary/12 text-accent-primary shadow-[0_0_20px_rgba(0,255,127,0.1)]': isActive,
                      'border-white/10 bg-white/5 text-text-secondary hover:text-white': !isActive
                    }
                  )
                }
              >
                <User size={16} />
                <span>{t('nav.profile')}</span>
              </NavLink>
            </div>
          </div>

          <div className="flex justify-center">
            <nav className="inline-flex flex-wrap items-center justify-center gap-3 rounded-[24px] border border-white/10 bg-dark-primary/40 p-2">
              {gameModeItems.map((item) => {
                const Icon = item.icon

                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    onClick={handleNavClick}
                    onMouseEnter={handleNavHover}
                    className={({ isActive }) =>
                      classNames(
                        'flex items-center gap-2 rounded-2xl px-4 py-3 text-sm font-medium transition-all duration-100',
                        {
                          'bg-accent-primary/15 text-accent-primary shadow-[0_0_24px_rgba(0,255,127,0.12)]': isActive,
                          'text-text-secondary hover:bg-white/5 hover:text-white': !isActive
                        }
                      )
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <Icon
                          size={18}
                          className={classNames({
                            'drop-shadow-[0_0_8px_rgba(0,255,127,0.6)]': isActive
                          })}
                        />
                        <span>{item.title}</span>
                      </>
                    )}
                  </NavLink>
                )
              })}
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
}

export default DesktopNavigation
